import { useT } from '@dia/i18n';
import { HelpThreadPage } from './parts/HelpThreadPage';

/**
 * /mensajes, the old Mensajes address. It still works (no address is removed,
 * docs/GUEST-REDESIGN.md), and it now draws the one help thread the sheet
 * draws, with the composer open on a plain message. Requests and problem
 * reports sit in the same thread as cards with their status.
 */
export function Mensajes() {
  const { t } = useT();
  return (
    <HelpThreadPage
      title={t('guest.messages.title')}
      lede={t('guest.messages.lede')}
      mode="message"
      signInFirst={t('guest.messages.sign_in_first')}
      locked={t('guest.messages.locked')}
    />
  );
}
